module.exports = __webpack_public_path__ + "img/Turkystan.fdd682df.png";